export default __webpack_public_path__ + "static/media/Ashoka_Particle_Flame_2.45238ea5.png";